import React from 'react';

const RandevuPrivacy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Gizlilik Politikası</h1>
      <p className="text-center text-gray-600 mb-4">Son güncelleme: 7 Temmuz 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          Bu gizlilik politikası, Randevu Defteri uygulamasının ("Uygulama") hangi verileri topladığını,
          nasıl kullandığını ve koruduğunu açıklar.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Toplanan Veriler</h2>
        <p>
          Uygulama, hizmeti sunabilmek için şu verileri toplar ve saklar:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>
            <strong>Hesap bilgileri:</strong> E-posta adresiniz (veya Apple ile giriş yaptıysanız Apple
            kimliğinizle ilişkili bilgiler), işletme adınız ve sektörünüz.
          </li>
          <li>
            <strong>Randevu verileri:</strong> Uygulamaya girdiğiniz müşteri adları, telefon numaraları,
            notlar, randevu tarih ve saatleri ile geldi/gelmedi durumları.
          </li>
        </ul>
        <p>
          Uygulama; konum, rehber, fotoğraf veya benzeri cihaz verilerine erişmez.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Verilerin Kullanım Amacı</h2>
        <p>
          Toplanan veriler yalnızca randevu takibi hizmetini sunmak, hesabınızı yönetmek ve uygulamayı
          çalıştırmak için kullanılır. Verileriniz:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Üçüncü taraflara satılmaz veya kiralanmaz.</li>
          <li>Reklam veya pazarlama amacıyla kullanılmaz ve paylaşılmaz.</li>
          <li>Profilleme amacıyla işlenmez.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">3. Verilerin Saklanması ve Güvenliği</h2>
        <p>
          Verileriniz Google Firebase altyapısında saklanır ve tüm veri aktarımı şifreli (SSL/TLS)
          bağlantılar üzerinden gerçekleşir. Her işletme yalnızca kendi hesabına ait verilere erişebilir;
          bu ayrım sunucu tarafı güvenlik kurallarıyla zorunlu kılınır. Firebase altyapısı nedeniyle
          verileriniz Google'ın veri merkezlerinde barındırılabilir; Google'ın veri işleme uygulamaları
          hakkında bilgiye Google Gizlilik Politikası üzerinden ulaşabilirsiniz.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Ödeme Bilgileri</h2>
        <p>
          Uygulama şu anda ücretsizdir. Gelecekte ücretli özellikler veya abonelik sunulması halinde tüm
          ödemeler Apple'ın App Store ödeme altyapısı üzerinden gerçekleştirilir. Kredi kartı veya ödeme
          bilgileriniz Uygulama tarafından toplanmaz, görülmez ve saklanmaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Veri Saklama Süresi ve Silme</h2>
        <p>
          Verileriniz, hesabınız aktif olduğu sürece saklanır. Şunları dilediğiniz zaman yapabilirsiniz:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Tek tek randevu kaydı silme (anında ve kalıcı olarak silinir).</li>
          <li>
            Ayarlar bölümünden hesabınızı tamamen silme — bu işlemle tüm hesap ve randevu verileriniz
            sunucularımızdan kalıcı olarak kaldırılır.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">6. Çerezler ve Takip</h2>
        <p>
          Uygulama reklam takibi yapmaz, üçüncü taraf reklam veya analitik SDK'sı kullanmaz ve cihazlar
          arası takip gerçekleştirmez.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Çocukların Gizliliği</h2>
        <p>
          Uygulama, işletme sahiplerine yöneliktir ve 18 yaş altı kullanıcıları hedeflemez. Bilerek
          çocuklardan veri toplanmaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. KVKK Kapsamındaki Haklarınız</h2>
        <p>
          6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında; verilerinize erişme, düzeltme, silme
          ve işlenmesine itiraz etme haklarına sahipsiniz. Bu haklarınızı kullanmak için aşağıdaki iletişim
          adresinden bize ulaşabilirsiniz. Not: Uygulamaya kaydettiğiniz müşteri verileri bakımından veri
          sorumlusu, kaydı yapan işletmedir; müşterileriniz bu verilerle ilgili taleplerini doğrudan
          işletmenize iletmelidir.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Politika Değişiklikleri</h2>
        <p>
          Bu politika gerektiğinde güncellenebilir. Önemli değişiklikler uygulama içinden duyurulur ve
          "son güncelleme" tarihi yenilenir.
        </p>

        <h2 className="text-xl font-semibold mt-8">10. İletişim</h2>
        <p>
          Gizlilikle ilgili soru ve talepleriniz için:
        </p>
        <p className="ml-4">
          E-posta: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600">hi@n1inovasyon.com</a>
        </p>
      </div>
    </div>
  );
};

export default RandevuPrivacy;
